import {setup, run} from '../../snippets/dotnet';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  'run-server': {
    Component: CreateShellCommand(run),
  },
};

export default ({
  keys,
  merchant,
  client,
  demo: {paymentMethods},
  activePrice,
  checkoutMode,
}) => `using System.Collections.Generic;
using Microsoft.AspNetCore;
using Microsoft.AspNetCore.Builder;
using Microsoft.AspNetCore.Hosting;
using Microsoft.AspNetCore.Mvc;
using Microsoft.Extensions.DependencyInjection;
using Microsoft.Extensions.Hosting;
using Stripe;
using Stripe.Checkout;

public class StripeOptions
{
    public string option { get; set; }
}

namespace server.Controllers
{
    public class Program
    {
        public static void Main(string[] args)
        {
            WebHost.CreateDefaultBuilder(args)
              .UseUrls("http://0.0.0.0:4242")
              .UseWebRoot("public")
              .UseStartup<Startup>()
              .Build()
              .Run();
        }
    }

    public class Startup
    {
        public void ConfigureServices(IServiceCollection services)
        {
            services.AddMvc().AddNewtonsoftJson();
        }
        public void Configure(IApplicationBuilder app, IWebHostEnvironment env)
        {
          {+setup}
            ${comment && comment(merchant)}
            StripeConfiguration.ApiKey = "${keys.secret}";
          {/setup}
            if (env.IsDevelopment()) app.UseDeveloperExceptionPage();
            app.UseRouting();
            app.UseStaticFiles();
            app.UseEndpoints(endpoints => endpoints.MapControllers());
        }
    }

    [Route("create-checkout-session")]
    [ApiController]
    public class CheckoutApiController : Controller
    {
        [HttpPost]
        public ActionResult Create()
        {
            var domain = "${
              client === 'react'
                ? 'http://localhost:3000/checkout'
                : 'http://localhost:4242'
            }";
            var options = new SessionCreateOptions
            {
                {?customize prefill-email}
                CustomerEmail = "customer@example.com",
                {/prefill-email}
                {?customize submit-button}
                SubmitType = "donate",
                {/submit-button}
                {?customize address}
                BillingAddressCollection = "auto",
                ShippingAddressCollection = new SessionShippingAddressCollectionOptions
                {
                  AllowedCountries = new List<string>
                  {
                    "US",
                    "CA",
                  },
                },
                {/address}
                {+line-items}
                LineItems = new List<SessionLineItemOptions>
                {
                  new SessionLineItemOptions
                  {
                    ${
                      activePrice
                        ? `Price = "${activePrice.id}"`
                        : `// TODO: replace this with the \`price\` of the product you want to sell
                    Price = "{{PRICE_ID}}"`
                    },
                    Quantity = 1,
                  },
                },
                {/line-items}
                {+payment-methods}
                PaymentMethodTypes = new List<string>
                {
                  ${
                    paymentMethods.length
                      ? paymentMethods
                          .map((key) => `"${key}",`)
                          .join('\n                  ')
                      : '// TODO: pass at least one option here'
                  }
                },
                {/payment-methods}
                {+mode}
                Mode = "${checkoutMode}",
                {/mode}
                {+urls}
                SuccessUrl = domain + "${
                  client === 'react' ? '?success=true' : '/success.html'
                }",
                CancelUrl = domain + "${
                  client === 'react' ? '?canceled=true' : '/cancel.html'
                }",
                {/urls}
                {?automatic-tax automatic-tax-param}
                AutomaticTax = new SessionAutomaticTaxOptions { Enabled = true },
                {/automatic-tax-param}
            };
            {+create}
            var service = new SessionService();
            Session {span response create}session{/span} = service.Create(options);

            {+redirect}
            Response.Headers.Add("Location", session.Url);
            return new StatusCodeResult(303);
            {/redirect}
            {/create}
        }
    }
}`;
